// Import jwtDecode as jwt_decode using alias

// Action Types
import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  TOKEN_REFRESH_SUCCESS,
  TOKEN_REFRESH_FAIL,
  FETCH_COSTUMER_LIST_REQUEST,
  FETCH_COSTUMER_LIST_SUCCESS,
  FETCH_COSTUMER_LIST_FAILURE,
} from "./actionTypes";
import axiosInstance from "../utils/axiosInstance";

// Register User
export const register =
  ({ email, username, password }) =>
  async (dispatch) => {
    try {
      const res = await axiosInstance.post("/accounts/register/", {
        email,
        username,
        password,
      });

      dispatch({
        type: REGISTER_SUCCESS,
        payload: res.data, // Adjust based on your backend response
      });

      // Optionally, redirect to login or perform additional actions
    } catch (err) {
      dispatch({
        type: REGISTER_FAIL,
        payload: err.response.data, // Adjust based on your backend error response
      });
    }
  };

// Login User
export const login =
  ({ email, password }) =>
  async (dispatch) => {
    try {
      const res = await axiosInstance.post(
        "/accounts/login/",
        {
          email,
          password,
        },
        { skipCompany: true, skipAuthRefresh: true, withCredentials: true },
      );

      // The refresh token arrives as an httpOnly cookie, not in the body.
      const { access_token, user, active_company } = res.data;

      localStorage.setItem("access_token", access_token);
      localStorage.removeItem("refresh_token");
      localStorage.setItem("user", JSON.stringify(user)); // Save as a string
      localStorage.setItem("active_company_id", String(active_company.id));
      localStorage.setItem("active_company", JSON.stringify(active_company));
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user, access_token },
      });
    } catch (err) {
      dispatch({
        type: LOGIN_FAIL,
        payload: err.response?.data || { detail: err.message },
      });
    }
  };

// Logout User
export const logout = () => (dispatch) => {
  // Clear the httpOnly refresh-token cookie on the server
  axiosInstance
    .post("/accounts/logout/", {}, { skipCompany: true, skipAuthRefresh: true, withCredentials: true })
    .catch(() => {});
  // Remove tokens from localStorage
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  dispatch({
    type: LOGOUT,
  });
};

// Refresh Token
export const refreshToken = () => async (dispatch) => {
  try {
    // The refresh token is sent automatically as an httpOnly cookie.
    const res = await axiosInstance.post(
      "/accounts/token/refresh/",
      {},
      { skipAuthRefresh: true, withCredentials: true },
    );

    const { access } = res.data;

    localStorage.setItem("access_token", access);

    dispatch({
      type: TOKEN_REFRESH_SUCCESS,
      payload: access,
    });
  } catch (err) {
    dispatch({
      type: TOKEN_REFRESH_FAIL,
      payload: err.response.data,
    });
  }
};

// export const fetchCostumers = () => async (dispatch) => {
//     dispatch({ type: FETCH_COSTUMER_LIST_REQUEST });
//     try {
//         const response = await axiosInstance.get('accounts/customer_list/');
//         dispatch({
//             type: FETCH_COSTUMER_LIST_SUCCESS,
//             payload: response.data,
//         });
//     } catch (error) {
//         dispatch({
//             type: FETCH_COSTUMER_LIST_FAILURE,
//             payload: error.response ? error.response.data.error : 'An error occurred.',
//         });
//     }
// };
export const fetchCostumers =
  (searchTerm = "") =>
  async (dispatch) => {
    dispatch({ type: FETCH_COSTUMER_LIST_REQUEST });
    try {
      const response = await axiosInstance.get("accounts/customer_list/", {
        params: { search: searchTerm }, // Support server-side search
        timeout: 5000,
      });
      dispatch({
        type: FETCH_COSTUMER_LIST_SUCCESS,
        payload: response.data.results, // Extract the 'result' array
      });
    } catch (error) {
      const errorMessage = error.response
        ? error.response.data.error ||
          `Error ${error.response.status}: Something went wrong`
        : error.message === "timeout of 5000ms exceeded"
        ? "Request timed out. Please try again."
        : "ارتباط با سرور برقرار نشد. اتصال اینترنت را بررسی کنید.";
      dispatch({
        type: FETCH_COSTUMER_LIST_FAILURE,
        payload: errorMessage,
      });
    }
  };
